import { useCallback, useState } from "react";

interface IUseDialog {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const useDialog = (): IUseDialog => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const close = useCallback(() => setIsOpen(false), [setIsOpen]);
  const open = useCallback(() => setIsOpen(true), [setIsOpen]);

  return {
    isOpen,
    close,
    open,
  };
};

export default useDialog;
